import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Attività recente',
  actions: {
    clicked: 'Cliccato',
    open: 'Aperto',
    scheduled: 'Pianificato',
    sent: 'Inviato',
  },
  fields: {
    recipients: '{{recipients}} Destinatari',
    opened: '{{rate}} Aperture',
    clicked: '{{rate}} Clic',
    awaiting: 'In attesa di conferma',
  },
  template_types: TemplateNames,
};
